import { render, staticRenderFns } from "./MySide.vue?vue&type=template&id=2ad57b65&"
import script from "./MySide.vue?vue&type=script&lang=js&"
export * from "./MySide.vue?vue&type=script&lang=js&"
import style0 from "./MySide.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports